import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import Plalist from '../../../../assets/images/playlist.svg'

import NestedHoverMenu from 'components_v1/nestedHoverMenu/NestedHoverMenu'
import { withRedux, withUser } from 'components_v1/reduxContainer'
import { userFollowedPlaylists } from 'redux/selectors/playlists'
import CreateNewPlaylistModal from 'components_v1/playlist/modals/CreateNewPlaylistModal'
import { createNewPlaylistEntry } from 'redux/actions/playlistEntries'

const PlaylistMenu = ({ playlists, addToPlaylist, planEntryId }) => {
  const [newPlayListModal, setNewPlayListModal] = useState(false)
  const [menus, setMenus] = useState([])

  useEffect(() => {
    const menuOptions = playlists.map((item) => {
      return {
        text: item.title,
        included: item.entryIds.some((id) => id === planEntryId),
        handleClick: () => {
          addToPlaylist(item.uuid)
        }
      }
    })

    menuOptions.unshift({
      text: 'New Playlist',
      handleClick: () => {
        setNewPlayListModal(true)
      }
    })

    setMenus(menuOptions)
  }, [playlists])

  return (
    <div>
      <NestedHoverMenu menuOptions={menus}>
        {({ animateIn }) => {
          return (
            <Plalist style={{ marginTop: '10px' }} onMouseEnter={animateIn} />
          )
        }}
      </NestedHoverMenu>
      <CreateNewPlaylistModal
        active={newPlayListModal}
        onHide={(item) => {
          setNewPlayListModal(false)
          if (item.uuid) {
            addToPlaylist(item.uuid)
          }
        }}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    playlists: userFollowedPlaylists(state)
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    addToPlaylist: (uuid) => {
      dispatch(createNewPlaylistEntry(uuid, props.planEntryId))
    }
  }
}

export default withRedux(
  withUser(connect(mapStateToProps, mapDispatchToProps)(PlaylistMenu))
)
